/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType } from './ComponentType';
import { CustomElementDefinition, CustomElementDefinitions, CustomElementTag } from './CustomElementDefinition';

const webComponentsSymbol: unique symbol = Symbol('WebComponents');

export function getComponentSelector(ctor: any): string | undefined {
  // 'ɵcmp' is where angular stores @Component metadata in class constructors.
  const selector: unknown = ctor['ɵcmp']?.['selectors'];

  if (!selector) {
    return undefined;
  }

  return `${Array.isArray(selector) ? selector[selector.length - 1] : selector}`;
}

export function getExportedComponents<T>(module: T): CustomElementDefinitions {
  const moduleConstructor = Object.getPrototypeOf(module).constructor;
  return (moduleConstructor as any)[webComponentsSymbol] ?? [];
}

function webComponentFn<T>(components: ComponentType<unknown>[], moduleConstructor: T): T {
  if (Array.isArray(components)) {
    const exportedComponents: CustomElementDefinitions = [];

    for (const component of components) {
      const selector: string | undefined = getComponentSelector(component);

      if (!selector) {
        continue;
      }

      const exportedComponent: CustomElementDefinition<unknown> = {
        component: component,
        tag: selector as CustomElementTag,
      };

      exportedComponents.push(exportedComponent);
    }

    (moduleConstructor as any)[webComponentsSymbol] = exportedComponents;
  }

  return moduleConstructor;
}

export function WebComponents<T>(components: ComponentType<unknown>[]) {
  // prettier would remove brackets, resulting in a ts compiler error
  // prettier-ignore
  return (webComponentFn<T>).bind(undefined, components);
}
